import { SearchProvider, is3SServiceAvailable } from 'owa-search';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';

export default function getSearchProvider() {
    if (isFeatureEnabled('cal-sea-executeSearch')) {
        return SearchProvider.ExecuteSearch;
    }

    if (!is3SServiceAvailable()) {
        return SearchProvider.ExecuteSearch;
    }

    if (isFeatureEnabled('cal-sea-executeSearchExplicitLogon')) {
        const userConfiguration = getUserConfiguration();
        const isExplicitLogon = userConfiguration?.SessionSettings?.IsExplicitLogon;

        return isExplicitLogon ? SearchProvider.ExecuteSearch : SearchProvider.Substrate;
    }

    return SearchProvider.Substrate;
}
